import axios from "axios";

export const getAllToDo = async () => {
  const { data } = await axios.get("/api/notes/get", { timeout: 20000 });
  if (!Array.isArray(data)) throw new Error("Invalid notes response");
  return data;
};
export const addToDo = (name, desc, linkcourse, lnknotes) =>
  axios.post(
    "/api/notes/save",
    { name, desc, linkcourse, lnknotes },
    { timeout: 20000 },
  );
